import src from '../assets/teetogreen.png';
import { imageLogo } from './imageLogo';

export const TeeToGreenLogo = imageLogo({
  src,
  width: 245,
  height: 240,
  alt: 'Tee to Green',
});
